import _asyncToGenerator from "D:/Projects/NET2/UJP/Ostalo/PorocevalskiPortal/PorocevalskiPortalApp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "regenerator-runtime/runtime.js";
import InputWrapper from '@/components/common/InputWrapper.vue';
import InputText from '@/components/common/InputText.vue';
import InputNumeric from '@/components/common/InputNumeric.vue';
import InputDate from '@/components/common/InputDate.vue';
import Select from '@/components/common/Select.vue';
import { errorMap, formatDate, formatNumber } from '@/lib/filters';
import { useApi } from '@/lib/api';
import { defineComponent, ref } from 'vue';
export default defineComponent({
  components: {
    InputWrapper: InputWrapper,
    InputText: InputText,
    InputNumeric: InputNumeric,
    InputDate: InputDate,
    Select: Select
  },
  props: {
    modelValue: {},
    disabled: {
      default: false
    },
    errorPrefix: {
      default: ''
    },
    cancellation: {},
    canCancel: {}
  },
  emits: ['update:modelValue', 'onCancel'],
  setup: function setup(props, ctx) {
    var _api = useApi();

    var currencyList = ref([]);

    var getSifData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _api.cache.get('sifList?type=currency');

              case 2:
                res = _context.sent;
                currencyList.value = res.data;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getSifData() {
        return _ref.apply(this, arguments);
      };
    }();

    var checkTaxNumber = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(t) {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(t.taxNumber.length > 3)) {
                  _context2.next = 10;
                  break;
                }

                if (!(t.taxNumber === '00000000')) {
                  _context2.next = 6;
                  break;
                }

                t.description = 'Fizična oseba/Tuj subjekt';
                ctx.emit('update:modelValue', props.modelValue);
                _context2.next = 10;
                break;

              case 6:
                _context2.next = 8;
                return _api.get('taxNumberCheck?taxNumber=' + t.taxNumber, false);

              case 8:
                res = _context2.sent;

                if (res.status === 200) {
                  if (res.data) {
                    t.description = res.data;
                    ctx.emit('update:modelValue', props.modelValue);
                  }
                }

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function checkTaxNumber(_x) {
        return _ref2.apply(this, arguments);
      };
    }();

    getSifData();
    return {
      errorMap: errorMap,
      currencyList: currencyList,
      checkTaxNumber: checkTaxNumber,
      formatDate: formatDate,
      formatNumber: formatNumber
    };
  }
});